import pricingService from "@/services/pricingService";

export function verifyCouponCodeApi(data) {
  return pricingService({
    url: "/item/promotion/verifyCouponCode",
    method: "post",
    data,
  });
}

export function getCustomerPromotionApi(params) {
  return pricingService({
    url: "/item/promotion/getCustomerPromotion",
    method: "get",
    params,
  })
}

export function getCouponInfoOfSampleApi(params) {
  return pricingService({
    url: "/item/promotion/getCouponInfoOfSample",
    method: "get",
    params,
  });
}

export function preCheckCouponUsageApi() {
  return pricingService({
    url: "/item/promotion/preCheckCouponUsage",
    method: "get",
  });
}